<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [endpoint]="'/promoter-sales/tables/user-analytics'"
      [name]="name"
      [chartColumn]="'Name'"
      [hasIndexCol]="true"
    ></app-api-table>
  }
</app-tab-layout>
